import { INPUT, INPUT_TYPES } from '$gbusiness/enums';
import InputRowModel from '$gbusiness/models/inputRow';
import { sleep, toNumber } from '$gbusiness/helpers/util';
import { requiredValidation } from '$gbusiness/helpers/input';

export const CREDIT_FORM = (stores, initialCredit): Array<InputRowModel> => [
  {
    items: [
      {
        input: INPUT.AUTOCOMPLETE,
        label: 'SCREEN.SERIAL.COLS.STORE',
        disableFastField: true,
        gridSize: 8,
        value: 'store',
        config: {
          optionProp: {
            label: 'name',
            value: 'id',
          },
          data: stores,
        },
      },
    ],
  },
  {
    items: [
      {
        label: 'SCREEN.CREDIT.COLS.DATE',
        value: 'creditDate',
        input: INPUT.DATE,
        gridSize: 4,
      },
      {
        ...INPUT_TYPES.AMOUNT,
        label: 'SCREEN.CREDIT.COLS.AMOUNT',
        value: 'total',
        gridSize: 4,
        onChange: async ({ value, formik, setFieldValue }) => {
          const diff = toNumber(value) - (initialCredit.total || 0);
          setFieldValue('balance', toNumber(initialCredit.balance) + diff);
          await sleep(100);
          formik.validateForm();
        },
        validation: [
          requiredValidation,
          {
            condition: (v) => {
              if (toNumber(v) < 0) return true;
              const diff = toNumber(v) - (initialCredit.total || 0);
              const newBalance = toNumber(initialCredit.balance) + diff;
              if (newBalance < 0) return true;
              return false;
            },
            message: 'CREDIT_AMOUNT',
          },
        ],
      },
      {
        ...INPUT_TYPES.AMOUNT,
        label: 'SCREEN.CREDIT.COLS.BALANCE',
        value: 'balance',
        disabled: true,
        gridSize: 4,
      },
      {
        input: INPUT.TEXTAREA,
        label: 'SCREEN.CREDIT.COLS.MEMO',
        value: 'memo',
        gridSize: 12,
      },
    ],
  },
];
